import { TextField } from "../../../../utils/form";

const Specialty = ({ form: { control }, ...props }) =>
  <TextField control={control} name="specialty" label="Especialidad" variant="outlined" style={{ width: "100%" }} {...props} />

export default Specialty;